module.exports = __webpack_public_path__ + "img/完成.ae0c05ac.svg";